import styled, { keyframes } from 'styled-components/macro';
import { FocusableParent, Focusable } from 'components/navigation';
import scaleSize from 'utils/scale-size';
import Button from 'components/Button';

export const StyledBlock = styled.div`
  width: ${scaleSize(680)}px;
  margin: ${scaleSize(55)}px auto;
`;

export const StyledTitle = styled.div`
  height: ${scaleSize(72)}px;
  font-size: ${scaleSize(48)}px;
  line-height: ${scaleSize(1.5, false)};
  letter-spacing: -0.33px;
  color: ${({ theme }) => theme.defaultColor};
  text-align: ${({ left }) => (left ? 'left' : 'center')};
`;

export const StyledDescription = styled.div`
  height: ${scaleSize(96)}px;
  font-size: ${scaleSize(34)}px;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: ${({ left }) => (left ? 'left' : 'center')};
  color: ${({ theme }) => theme.iconDefaultColor};
`;

export const FocusableActionsWrapper = styled(FocusableParent)`
  margin-top: ${scaleSize(164)}px;
  text-align: center;
`;

export const StyledButtonWrapper = styled.div`
  margin-bottom: ${scaleSize(20)}px;
`;

export const StyledButton = styled(Button)`
  min-width: ${scaleSize(600)}px;
  height: ${scaleSize(80)}px;
  font-size: ${scaleSize(34)}px;
  line-height: ${scaleSize(80)}px;
  padding-left: ${scaleSize(40)}px;
  margin-bottom: ${scaleSize(15)}px;
  color: ${({ theme, selected }) => (selected ? theme.activeColor : theme.mainTextColor)};
  box-sizing: border-box;
  border-radius: ${scaleSize(12)}px;
  border: none;
  text-align: left;
  display: inline-block;
  position: relative;
  font-family: RobotoMedium, sans-serif;

  svg {
    display: ${({ selected }) => (selected ? 'inline-block' : 'none')};
    padding-left: ${scaleSize(20)}px;

    & > path {
      stroke: ${({ theme }) => theme.activeColor};
      fill: none;
    }
  }

  &:focus {
    background-color: ${({ theme }) => theme.activeColor};
    color: ${({ theme }) => theme.activeColorText};

    svg > path {
      stroke: ${({ theme }) => theme.activeColorText};
      fill: none;
    }
  }
`;

export const StyledButtonText = styled.div`
  min-width: ${scaleSize(618)}px;
  height: ${scaleSize(80)}px;
`;

export const StyledInputWrapper = styled.div`
  margin-bottom: ${scaleSize(20)}px;
`;

const errorAnimation = keyframes`
    0% { transform: translate(30px); }
    20% { transform: translate(-30px); }
    40% { transform: translate(15px); }
    60% { transform: translate(-15px); }
    80% { transform: translate(8px); }
    100% {transform: translate(0px); }
`;

export const StyledInput = styled(Focusable)`
  display: block;
  width: ${scaleSize(672)}px;
  height: ${scaleSize(88)}px;
  border-radius: ${scaleSize(12)}px;
  border-style: solid;
  border-width: ${scaleSize(4)}px;
  border-color: ${({ isValid, theme }) => (isValid ? 'transparent' : theme.invalidInput)};
  background-color: ${({ theme }) => theme.submenuActiveColor};
  overflow: hidden;
  animation-name: ${({ isValid }) => (isValid ? '' : errorAnimation)};
  animation-duration: 0.4s;
  animation-iteration-count: 1;

  &:focus {
    border-color: ${({ theme }) => theme.activeColor};
  }
`;

const cursorAnimation = keyframes`
  0% {opacity: 0;}
  50% {opacity: 1;}
  100% {opacity: 0;}
`;

export const StyledInputCursor = styled.div`
  display: inline-block;
  width: 2px;
  height: ${scaleSize(50)}px;
  vertical-align: middle;
  margin-top: -${scaleSize(4)}px;
  margin-left: -1px;
  background: ${({ theme }) => theme.mainTextColor};
  animation-name: ${cursorAnimation};
  animation-duration: 1s;
  animation-iteration-count: infinite;
`;

export const StyledInputText = styled.div`
  height: ${scaleSize(48)}px;
  min-width: ${scaleSize(600)}px;
  float: right;
  margin: 0 ${scaleSize(36)}px;
  text-align: center;
  white-space: nowrap;
  font-size: ${scaleSize(40)}px;
  line-height: ${scaleSize(88)}px;
  letter-spacing: ${scaleSize(-0.28)}px;
  color: ${({ isActive, theme }) => theme[isActive ? 'defaultColor' : 'iconDefaultColor']};
`;

export const StyledInputInvalidMessage = styled.div`
  max-height: ${scaleSize(80)}px;
  margin-top: ${scaleSize(12)}px;
  font-size: ${scaleSize(32)}px;
  text-align: left;
  font-family: 'RobotoRegular', sans-serif;
  line-height: 1.25;
  letter-spacing: -0.22px;
  color: ${({ theme }) => theme.invalidInput};
`;

export const StyledKeyboardWrapper = styled.div`
  width: ${scaleSize(1920)}px;
  height: ${scaleSize(420)}px;
  background-color: ${({ theme }) => theme.imagePlaceholder};
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 0;
  padding-left: ${scaleSize(20)}px;

  & > div {
    margin-top: ${scaleSize(40)}px;
    margin-bottom: ${scaleSize(40)}px;
  }
`;
